// TODO: remove usage of enums, instead use object with as const
export var RecoveryShareManagement;
(function (RecoveryShareManagement) {
    RecoveryShareManagement["USER_MANAGED"] = "USER_MANAGED";
    RecoveryShareManagement["CLOUD_MANAGED"] = "AWS_MANAGED";
})(RecoveryShareManagement || (RecoveryShareManagement = {}));
// TODO: remove usage of enums, instead use object with as const
export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["COGNITO"] = "Cognito";
    AuthProvider["GOOGLE"] = "Google";
    AuthProvider["EMAIL_OTP"] = "EmailOtp";
    AuthProvider["CUSTOM_JWT"] = "CustomJWT";
    AuthProvider["CUSTOM_AUTH_ENDPOINT"] = "CustomAuthEndpoint";
    AuthProvider["FACEBOOK"] = "Facebook";
    AuthProvider["APPLE"] = "Apple";
    AuthProvider["PASSKEY"] = "Passkey";
    AuthProvider["DISCORD"] = "Discord";
    AuthProvider["FARCASTER"] = "Farcaster";
    AuthProvider["TELEGRAM"] = "Telegram";
})(AuthProvider || (AuthProvider = {}));
// In APp Wallet Types
export var UserWalletStatus;
(function (UserWalletStatus) {
    UserWalletStatus["LOGGED_OUT"] = "Logged Out";
    UserWalletStatus["LOGGED_IN_WALLET_UNINITIALIZED"] = "Logged In, Wallet Uninitialized";
    UserWalletStatus["LOGGED_IN_NEW_DEVICE"] = "Logged In, New Device";
    UserWalletStatus["LOGGED_IN_WALLET_INITIALIZED"] = "Logged In, Wallet Initialized";
})(UserWalletStatus || (UserWalletStatus = {}));
//# sourceMappingURL=types.js.map